'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_ju_UUID(mostSigBits_$_lo, mostSigBits_$_hi, leastSigBits_$_lo, leastSigBits_$_hi) {
  this.kE = 0;
  this.kF = 0;
  this.kC = 0;
  this.kD = 0;
  this.kE = mostSigBits_$_lo;
  this.kF = mostSigBits_$_hi;
  this.kC = leastSigBits_$_lo;
  this.kD = leastSigBits_$_hi;
}
export { $c_ju_UUID as $c_ju_UUID };
$p = $c_ju_UUID.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
}
export { $h_ju_UUID as $h_ju_UUID };
$h_ju_UUID.prototype = $p;
$p.b = (function() {
  var mostSigBits_$_lo = this.kE;
  var mostSigBits_$_hi = this.kF;
  var leastSigBits_$_lo = this.kC;
  var leastSigBits_$_hi = this.kD;
  var s = (mostSigBits_$_hi >>> 0.0).toString(16);
  var beginIndex = s.length;
  var $x_5 = "00000000".substring(beginIndex);
  var i = (65535 & (((mostSigBits_$_lo >>> 16) | 0) | (mostSigBits_$_hi << 16)));
  var s$1 = (i >>> 0.0).toString(16);
  var beginIndex$1 = s$1.length;
  var $x_4 = "0000".substring(beginIndex$1);
  var i$1 = (65535 & mostSigBits_$_lo);
  var s$2 = (i$1 >>> 0.0).toString(16);
  var beginIndex$2 = s$2.length;
  var $x_3 = "0000".substring(beginIndex$2);
  var i$2 = (65535 & ((leastSigBits_$_hi >>> 16) | 0));
  var s$3 = (i$2 >>> 0.0).toString(16);
  var beginIndex$3 = s$3.length;
  var $x_2 = "0000".substring(beginIndex$3);
  var i$3 = (65535 & leastSigBits_$_hi);
  var s$4 = (i$3 >>> 0.0).toString(16);
  var beginIndex$4 = s$4.length;
  var $x_1 = "0000".substring(beginIndex$4);
  var s$5 = (leastSigBits_$_lo >>> 0.0).toString(16);
  var beginIndex$5 = s$5.length;
  return ((((((((((("" + $x_5) + s) + "-") + (("" + $x_4) + s$1)) + "-") + (("" + $x_3) + s$2)) + "-") + (("" + $x_2) + s$3)) + "-") + (("" + $x_1) + s$4)) + (("" + "00000000".substring(beginIndex$5)) + s$5));
});
$p.m = (function() {
  var value_$_lo = this.kE;
  var value_$_hi = this.kF;
  var value$1_$_lo = this.kC;
  var value$1_$_hi = this.kD;
  return ((value_$_lo ^ value_$_hi) ^ (value$1_$_lo ^ value$1_$_hi));
});
$p.f = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var x_$_lo = this.kE;
    var x_$_hi = this.kF;
    var $x_1 = that;
    var x$1_$_lo = $x_1.kE;
    var x$1_$_hi = $x_1.kF;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.kC;
      var x$2_$_hi = this.kD;
      var $x_2 = that;
      var x$3_$_lo = $x_2.kC;
      var x$3_$_hi = $x_2.kD;
      return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.SO = (function(that) {
  var thisHi_$_lo = this.kE;
  var thisHi_$_hi = this.kF;
  var $x_1 = that;
  var thatHi_$_lo = $x_1.kE;
  var thatHi_$_hi = $x_1.kF;
  if ((((thisHi_$_lo ^ thatHi_$_lo) | (thisHi_$_hi ^ thatHi_$_hi)) !== 0)) {
    return (((thisHi_$_hi === thatHi_$_hi) ? ((thisHi_$_lo >>> 0) < (thatHi_$_lo >>> 0)) : (thisHi_$_hi < thatHi_$_hi)) ? (-1) : 1);
  } else {
    var thisLo_$_lo = this.kC;
    var thisLo_$_hi = this.kD;
    var $x_2 = that;
    var thatLo_$_lo = $x_2.kC;
    var thatLo_$_hi = $x_2.kD;
    return ((((thisLo_$_lo ^ thatLo_$_lo) | (thisLo_$_hi ^ thatLo_$_hi)) !== 0) ? (((thisLo_$_hi === thatLo_$_hi) ? ((thisLo_$_lo >>> 0) < (thatLo_$_lo >>> 0)) : (thisLo_$_hi < thatLo_$_hi)) ? (-1) : 1) : 0);
  }
});
$p.fh = (function(o) {
  return this.SO(o);
});
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dV)));
}
export { $isArrayOf_ju_UUID as $isArrayOf_ju_UUID };
var $d_ju_UUID = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_UUID, "java.util.UUID", ({
  dV: 1,
  a: 1,
  j: 1
}));
export { $d_ju_UUID as $d_ju_UUID };
